module.exports = __webpack_public_path__ + "img/ascent-logo.ff659450.jpg";